import { VisitQuery } from '@dreryk/egabinet-visit-frontend-api';
import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import {
   Dropdown,
   IconFillColor,
   IconWrapper,
   LinkIconVariant,
   LinkVariant,
   ShieldIcon,
   ShieldProtectedIcon,
   StyledFlex,
   StyledMargin,
} from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { visitTranslationKeys } from '../../translations';

import { useVisitUpdateConfidentialityLevelCqrsCommand } from './VisitConfidentialityLevelDropdown.hooks';

const t = visitTranslationKeys.controlsBar.visitConfidentialityLevel;

type VisitConfidentialityLevelDropdownProps = {
   visitId: number;
   confidentialityLevel: ConfidentialityLevel | undefined;
};

const iconByLevelMap: Record<ConfidentialityLevel, JSX.Element> = {
   NORMAL: <ShieldIcon />,
   CONFIDENTIAL: <ShieldProtectedIcon />,
};

const labelByLevelMap: Record<ConfidentialityLevel, string> = {
   NORMAL: t.NORMAL,
   CONFIDENTIAL: t.CONFIDENTIAL,
};

export const VisitConfidentialityLevelDropdown = (props: VisitConfidentialityLevelDropdownProps): JSX.Element => {
   const { executeAsync: updateConfidentialityLevel } = useVisitUpdateConfidentialityLevelCqrsCommand({
      visitId: props.visitId,
      onSuccess: () => {
         refetchCqrsQuery(VisitQuery);
      },
   });

   const { confidentialityLevel = 'NORMAL' } = props;

   return (
      <Dropdown
         testId={'visitConfidentialityLevel'}
         triggerLabel={labelByLevelMap[confidentialityLevel]}
         triggerIcon={
            <StyledMargin right={4}>
               <IconWrapper testId={'visitConfidentialityLevelIcon'} fillColor={IconFillColor.BACKGROUND}>
                  {iconByLevelMap[confidentialityLevel]}
               </IconWrapper>
            </StyledMargin>
         }
         variant={LinkVariant.STANDARD}
         triggerIconSuffixVariant={LinkIconVariant.PRIMARY}
         maxWidth={176}
      >
         <Dropdown.Item
            testId={'normal'}
            onClick={(hide) => {
               updateConfidentialityLevel('NORMAL');
               hide();
            }}
         >
            <StyledFlex alignItems={'center'} gap={4}>
               <IconWrapper testId={'normal'} fillColor={IconFillColor.BACKGROUND}>
                  <ShieldIcon />
               </IconWrapper>
               <Translate>{t.NORMAL}</Translate>
            </StyledFlex>
         </Dropdown.Item>
         <Dropdown.Item
            testId={'confidential'}
            onClick={(hide) => {
               updateConfidentialityLevel('CONFIDENTIAL');
               hide();
            }}
         >
            <StyledFlex alignItems={'center'} gap={4}>
               <IconWrapper testId={'confidential'} fillColor={IconFillColor.BACKGROUND}>
                  <ShieldProtectedIcon />
               </IconWrapper>
               <Translate>{t.CONFIDENTIAL}</Translate>
            </StyledFlex>
         </Dropdown.Item>
      </Dropdown>
   );
};
